import { useContext } from 'react'
import { SellerInformationIcon } from 'src/components/Icons/SellerInformationIcon'
import { ProductContext } from 'src/components/restructure/product/contexts'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'

const b2bLinkWithUtm =
  'https://empresas.decathlon.com.br?origin=destaque_b2b&utm_source=pdp_Desk-Site_B2C'

const COLLECTION_TO_SHOW_B2B_MESSAGE = '3642'

type Props = {
  isMobileFirstFoldRevamp?: boolean
}

const STYLES = {
  container: {
    default:
      'flex flex-col items-start justify-between mt-6 pb-6 border-b border-gray',
    revamp: 'flex flex-col items-start gap-2',
  },
  sellerText: {
    revamp: 'text-[14px] font-medium leading-[21px] text-[#15181B]',
  },
  b2bText: 'text-xs text-tertiary font-medium leading-[150%]',
} as const

export function SellerInformation({ isMobileFirstFoldRevamp = false }: Props) {
  const styleVariant = isMobileFirstFoldRevamp ? 'revamp' : 'default'

  const { currentSku, product } = useContext(ProductContext)
  const { sellerDefault } = currentSku
  const showB2BMessage = product?.productClusters?.some(
    (cluster) => cluster.id === COLLECTION_TO_SHOW_B2B_MESSAGE
  )

  return (
    <div className={STYLES.container[styleVariant]}>
      {isMobileFirstFoldRevamp ? (
        <p className={STYLES.sellerText.revamp} data-testid="sellerNameText">
          Vendido e entregue por {sellerDefault.sellerName}
        </p>
      ) : (
        <p
          className="flex items-center desktop-caption-regular text-restructure-tertiary"
          data-testid="sellerNameText"
        >
          <SellerInformationIcon />
          <span className="ml-xxs mr-xxxs">Vendido e entregue por</span>
          <strong className="desktop-caption-semibold">
            {sellerDefault.sellerName}
          </strong>
        </p>
      )}
      {showB2BMessage && (
        <p className={STYLES.b2bText}>
          Saiba mais sobre{' '}
          <strong className="font-bold">compras com CNPJ:</strong>{' '}
          <FlexibleLink
            linkUrl={b2bLinkWithUtm}
            classNames="text-primaryBlue underline"
          >
            acesse aqui
          </FlexibleLink>
        </p>
      )}
    </div>
  )
}
